import { Box, CircularProgress, Container, Typography } from "@mui/material";

export const Loader = ({
  loading,
  label = "Un Momento..",
}) =>
  loading ? (
    <Container maxWidth="lg" sx={{ mt: 3, py: 4 }}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="400px"
      >
        <CircularProgress size={60} sx={{ mb: 2 }} />
        <Typography variant="h6" color="text.primary">
          {label}
        </Typography>
      </Box>
    </Container>
  ) : null;